import { colors } from "./colors";

export const trimAddress = (address: string, to = 6, from = 38) =>
	`${address.toString().slice(0, to)} … ${address.toString().slice(from)}`;
export const trimText = (text: string, length: number, withDots: boolean = false) => {
	if (text.length < length) return text;
	return text.slice(0, length) + (withDots ? '...' : '');
};

export const isHexColor = (hex: string) => hex.match(/^#[a-f0-9]{6}$/i) !== null;
export const getYoutubeId = (url: string) => {
	const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
	const match = url.match(regExp);
	return match && match[7].length === 11 ? match[7] : false;
};

export const licenseColorToHex = (color: string) : string => {
	if(color == "gold")
		return colors.cartridge.gold
	if(color == "gray" || color == "grey")
		return colors.cartridge.gray
	return "blue"
}

export const nFormatter = (num : number, digits : number) => {
	const lookup = [
	  { value: 1, symbol: "" },
	  { value: 1e3, symbol: "K" },
	  { value: 1e6, symbol: "M" },
	  { value: 1e9, symbol: "G" },
	  { value: 1e12, symbol: "T" },
	  { value: 1e15, symbol: "P" },
	  { value: 1e18, symbol: "E" }
	]
	
	const rx = /\.0+$|(\.[0-9]*[1-9])0+$/
	const item = lookup.slice().reverse().find((item) => {
	  return num >= item.value
	})
	return item ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : "0"
  }